import React, { useState } from 'react';
import Modal from 'react-modal';
import { toast } from 'react-toastify';
import CustomerProfileService from './CustomerProfileService';

const modalStyles = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.75)',
    zIndex: 1000,
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    height: 'auto',
    maxHeight: '90vh',
    width: '520px',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    overflow: 'auto',
  },
};

const PromoteLinkModal = ({ isOpen, onClose, profile }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [linkData, setLinkData] = useState(null);

  const alreadyPromoted = Boolean(profile?.userId);

  const handleClose = () => {
    setLinkData(null);
    onClose();
  };

  const handleGenerate = async () => {
    if (!profile?.id) {
      toast.error('ไม่พบโปรไฟล์ลูกค้า');
      return;
    }
    setIsLoading(true);
    try {
      const res = await CustomerProfileService.createPromoteLink(profile.id);
      setLinkData(res.data);
    } catch (err) {
      toast.error(err.response?.data?.message || 'สร้างลิงก์ไม่สำเร็จ');
    } finally {
      setIsLoading(false);
    }
  };

  const copyText = async (text) => {
    try {
      await navigator.clipboard.writeText(text || '');
      toast.success('คัดลอกแล้ว');
    } catch {
      toast.error('คัดลอกไม่สำเร็จ');
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleClose}
      style={modalStyles}
      ariaHideApp={false}
    >
      <div className="p-6">
        <h2 className="mb-1 text-2xl font-bold">โปรโมทลูกค้าเข้าแพลตฟอร์ม</h2>
        <p className="mb-4 text-sm text-gray-500">
          {profile?.customerName || profile?.smileName}
        </p>

        {alreadyPromoted ? (
          <div className="rounded-lg bg-yellow-50 p-4 text-yellow-800">
            ลูกค้ารายนี้มีบัญชีแพลตฟอร์มแล้ว
          </div>
        ) : !linkData ? (
          <div className="space-y-4">
            <p className="text-sm text-gray-600">
              สร้างลิงก์เพื่อส่งให้ลูกค้าในแชท LINE ลูกค้าจะยืนยันด้วย OTP
              ทางอีเมลและเบอร์โทรของบัญชีเดิม แล้วตั้งรหัสผ่านเพื่อเข้าใช้งานเอง
            </p>
            <button
              type="button"
              onClick={handleGenerate}
              disabled={isLoading}
              className="w-full rounded-md bg-blue-600 px-4 py-2 text-white hover:bg-blue-700 disabled:bg-gray-400"
            >
              {isLoading ? 'กำลังสร้าง...' : 'สร้างลิงก์'}
            </button>
          </div>
        ) : (
          <div className="space-y-4">
            <div>
              <label className="text-sm font-medium text-gray-600">ลิงก์สำหรับลูกค้า</label>
              <div className="mt-2 flex gap-2">
                <input
                  type="text"
                  readOnly
                  value={linkData.url}
                  onFocus={(e) => e.target.select()}
                  className="flex-1 rounded-md border border-gray-300 bg-white px-3 py-2 text-sm"
                />
                <button
                  type="button"
                  onClick={() => copyText(linkData.url)}
                  className="rounded-md bg-green-600 px-4 py-2 text-white hover:bg-green-700"
                >
                  คัดลอก
                </button>
              </div>
            </div>
            <p className="text-xs text-gray-500">ลิงก์นี้ใช้ได้ 7 วัน และใช้ได้ครั้งเดียว</p>
          </div>
        )}

        <button
          type="button"
          onClick={handleClose}
          className="mt-6 w-full rounded-md bg-gray-500 px-4 py-2 text-white hover:bg-gray-600"
        >
          ปิด
        </button>
      </div>
    </Modal>
  );
};

export default PromoteLinkModal;
